
import { useContext, useState, useEffect } from "react";
import {useNavigate} from "react-router-dom";



import "./navbar.scss";
// import { Link } from "react-router-dom";
import { AuthContext } from "../../context/AuthContext";
import { useNotificationStore } from "../../lib/notificationStore.js";
import { useNavigationLocation } from "../../context/navigationContext.jsx";

// import apiRequest from "../../lib/apiRequest.js";
import LinkWithCallback from "../linknav/LinkWithCallback.jsx"; // Import the custom Link component

import logo from "../../assets/logo.png";
import noavatar from "../../assets/noavatar.png";
import menuIcon from "../../assets/menu.png";
import noimage from "../../assets/no-image-icon-23494.png";
import { useChat } from "../../context/chatContext.jsx";
import { isLocalhost } from "../../../checkLocalhost.jsx";
import { BhoomiLogoIcon, LogoIcon, PulsingLogo,BasketIcon } from "../../lib/myIcons.jsx";

// import { useNavigate } from "react-router-dom";


function Navbar() {
  // console.log("🔥 Vite Build 2025-06-24 21:30 - USING logo.png");
  // console.log("🔥 FORCING BUILD REFRESH");
  // console.log("BASE_URL:", import.meta.env.BASE_URL);
  const navigate = useNavigate();

  const [open, setOpen] = useState(false);
  const { currentUser } = useContext(AuthContext);
  // const {useChat} = useChat();

  
  const avatarfolder=import.meta.env.VITE_AVATARIMAGE_FOLDER

  // console.log("avatar folder",avatarfolder)
  const avatarimagelocation =isLocalhost
    ?import.meta.env.VITE_AVATARIMAGES_BASEURL + currentUser?.id + avatarfolder
    :import.meta.env.VITE_AVATARIMAGES_SH_BASEURL + currentUser?.id + avatarfolder
    // Ensure this is the correct path to your avatar images


// console.log("avatar image location",avatarimagelocation)

  const { unreadCount } = useChat();

  // const fetchNotifications = useNotificationStore((state) => state.fetch);
  // const number = useNotificationStore((state) => state.number);  /i.e. unreadcount as used now

  // fetchNotifications();
  // console.log(number);

  // this was part of old code, with websocket, but getting from previous database hence not relavant

  // useEffect(() => {
  //   // Call the fetch function to load notifications
  //   if (currentUser){

  //     fetchNotifications();
  //   }
  // }, [fetchNotifications,currentUser]);

  useEffect(() => {}, [currentUser]);

  const handleLinkClick = (link, e) => {
    // event.preventDefault(); // Prevent default link behavior

    e.preventDefault();
    var filterlink = {};
  
    switch (link) {
      case "floor":
        // Handle the click event for  the link
        // console.log(`Floors Link clicked: ${link}`);

        // Appartment,Builder Floor, Floor
        filterlink.propertytype= [1,2,13];
        break;
      case "project":
        // Handle the click event for  the link
        // DDA Flat, Flat
        // filterlink.propertytype = [9,12];

        navigate("/projects", {
          state:{
            ...filterlink,
            fromMenu:true,
            refresh: Date.now(),
          }
        });
        return;

        // console.log(`Flats Link clicked: ${link}`);
        break;
      case "house":
        // Handle the click event for  the link
        // House, Kothi,plot
        filterlink.propertytype =[18,22,28];

        // console.log(`Houses Link clicked: ${link}`);
        break;
      case "commercial":
        // Handle the click event for  the link

        // Appartment,Builder Floor, Floor
        filterlink.propertytype = [4,5,25,34,36,31,19];

        // console.log(`Commercials Link clicked: ${link}`);
        break;
      case "farm":
        // Handle the click event for  the link

        // Appartment,Builder Floor, Floor
        filterlink.propertytype = [10,11,23];

        // console.log(`Farms Link clicked: ${link}`);
        break;

        // Handle other links if needed
        otherwise: console.log(`unkknow Link clicked: ${link}`);
        break;
    }

    // console.log(`Filter link: ${filterlink}`);
    // navigate(`/list?${filterlink}`);
    // navigate(`/list?${filterlink}&_=${Date.now()}`);

    // navigate(`/list?${encodeURIComponent(filterlink)}`);

    navigate("/list", {
      state:{
        ...filterlink,
        fromMenu:true,
        refresh: Date.now(),
      }
    });





  };

  return (
    <nav className="navbar">

      <div className="left">
        <LinkWithCallback to="/" className="logo">
          {/* <img src={logo} alt="" /> */}

          <div className="logoBox">
            {/* <BhoomiLogoIcon    size={"60pt"}></BhoomiLogoIcon> */}
            {/* animate fade,rotate,pulse,splash */}
            <LogoIcon size={"42px"} color="gold"  > </LogoIcon>


          </div>



          <span className="company">Bhoomi India Realtors</span>
          <span className="companydesc">
            Sale Purchase Renting and Collaborations
          </span>
        </LinkWithCallback>
      </div>

      <div className="middle">
        <div className="links">
          <LinkWithCallback to="" onClick={(e) => handleLinkClick("floor", e)}>
            Floors
          </LinkWithCallback>
          <LinkWithCallback to="" onClick={(e) => handleLinkClick("project", e)}>
            Projects
          </LinkWithCallback>
          <LinkWithCallback to="" onClick={(e) => handleLinkClick("house", e)}>
            Houses
          </LinkWithCallback>
          <LinkWithCallback
            to=""
            onClick={(e) => handleLinkClick("commercial", e)}
          >
            Commercials
          </LinkWithCallback>
          <LinkWithCallback to="" onClick={(e) => handleLinkClick("farm", e)}>
            Farms
          </LinkWithCallback>
        </div>
      </div>

      <div className="right">
        {/* {console.log("🔥 currentUser in Navbar:", currentUser) || null} */}

        {/* Basket Icon - visible for all users */}
        <LinkWithCallback to="/dashboard" className="basketIcon">
          <BasketIcon size={24} color="currentColor" />
          {/* Optional count */}
          <span className="basketCount">3</span>
        </LinkWithCallback>




        {currentUser ? (
          <div className="user">
            <LinkWithCallback to="/dashboard/inbox" className="profile">
              <img
                src={
                  !currentUser.avatar
                    ? noavatar
                    : currentUser.avatar.startsWith("https")
                    ? currentUser.avatar
                    : currentUser.avatar.startsWith("http")
                    ? noavatar // fallback for non-https URLs
                    : avatarimagelocation + currentUser.avatar
                }
                alt=""
                onError={(e) => {
                  e.target.onerror = null; // Prevent infinite loop if fallback also fails
                  e.target.src = noimage; // Fallback image URL or local path
                  e.target.style.width = "40px";
                  e.target.style.height = "40px";
                  e.target.style.display = "block";
                }}
              />


          {/* <img
            src={
              !currentUser.avatar
                ? noavatar
                : currentUser.avatar.startsWith("https")
                ? currentUser.avatar
                : currentUser.avatar.startsWith("http")
                ? noavatar
                : `${avatarimagelocation}${currentUser.avatar}?t=${currentUser.updatedAt || Date.now()}`
            }
            alt=""
            onError={(e) => {
              e.target.onerror = null;
              e.target.src = noimage;
              e.target.style.width = "40px";
              e.target.style.height = "40px";
              e.target.style.display = "block";
            }}
          /> */}



              <div className="profile-content">
                <span>{currentUser.username}</span>
                {/* <div className="notification">88</div>} */}
                {unreadCount > 0 && (
                  <div className="notification">{unreadCount}</div>
                )}
              </div>
            </LinkWithCallback>
          </div>
        ) : (
          <>
            {/* {console.log("🔥 Currentuser not found:", currentUser) || null} */}

            <LinkWithCallback to="/login" className="signin">
              Sign in
            </LinkWithCallback>
            <LinkWithCallback to="/register" className="register">
              Sign up
            </LinkWithCallback>
          </>
        )}

        <div className="menuIcon">
          <img src={menuIcon} alt="" onClick={() => setOpen((prev) => !prev)} />
        </div>
        <div className={open ? "menu active" : "menu"}>
          <LinkWithCallback to="/list" onClick={(e) => handleLinkClick("floor", e)} >Floors</LinkWithCallback>
          <LinkWithCallback to="/list" onClick={(e) => handleLinkClick("flat", e)} >Projects</LinkWithCallback>
          <LinkWithCallback to="/list" onClick={(e) => handleLinkClick("house", e)}>Houses</LinkWithCallback>
          <LinkWithCallback to="/list" onClick={(e) => handleLinkClick("commercial", e)}>Commercial</LinkWithCallback>
          <LinkWithCallback to="/list" onClick={(e) => handleLinkClick("farm", e)}>Farms</LinkWithCallback>

          <LinkWithCallback to="/login">Sign in</LinkWithCallback>
          <LinkWithCallback to="/register">Sign up</LinkWithCallback>
          {currentUser ?
             <LinkWithCallback to="/dashboard/profile">Profile</LinkWithCallback>
            :
              <LinkWithCallback to="/">Home</LinkWithCallback>
           
          }
        
        </div>
      </div>
    </nav>
  );
}

export default Navbar;
